import { supabase } from '@/lib/supabase';

export type DriveUploadFormType = 'incident' | 'denunciation';

export interface DriveUploadResult {
  fileId: string;
  folderId: string;
  webViewLink: string;
  webContentLink?: string;
}

function getFileBase64(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || '');
      resolve(result.includes(',') ? result.split(',')[1] : result);
    };
    reader.onerror = () => reject(new Error('Não foi possível ler o arquivo selecionado.'));
    reader.readAsDataURL(file);
  });
}

export async function uploadFormFileToGoogleDrive({
  formType,
  submissionId,
  file,
}: {
  formType: DriveUploadFormType;
  submissionId: string;
  file: File;
}): Promise<DriveUploadResult> {
  const fileBase64 = await getFileBase64(file);

  const { data, error } = await supabase.functions.invoke('upload-google-drive', {
    body: {
      formType,
      submissionId,
      fileName: file.name,
      mimeType: file.type || 'application/octet-stream',
      fileBase64,
    },
  });

  if (error) {
    const context = (error as { context?: Response }).context;
    if (context) {
      try {
        const body = await context.clone().json();
        if (body?.error) throw new Error(body.error);
      } catch (err) {
        if (err instanceof Error) throw err;
      }
    }
    throw new Error(error.message || 'Erro ao enviar arquivo para o Google Drive.');
  }

  if (data?.error) {
    throw new Error(data.error);
  }

  return data as DriveUploadResult;
}
